import { Validators } from "@angular/forms";
import { DropShadowProperties, FormType, Properties, SepiaProperties } from "../properties.model";
import { EffectsType } from "../ui-effects.model";

export const dropShadowForm: Properties = {
  propertyType: EffectsType.DropShadow,
  label: 'Drop Shadow',
  forms: [
    {
      id: DropShadowProperties.DropShadowColor,
      label: 'Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#000000',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: DropShadowProperties.DropShadowOffsetX,
      label: 'Offset X',
      type: FormType.InputNumber,
      defaultValue: 1,
      suffix: 'px',
      validators: [Validators.required],
    },
    {
      id: DropShadowProperties.DropShadowOffsetY,
      label: 'Offset Y',
      type: FormType.InputNumber,
      defaultValue: 1,
      suffix: 'px',
      validators: [Validators.required],
    },
    {
      id: DropShadowProperties.DropShadowLength,
      label: 'Shadow Length',
      type: FormType.InputNumber,
      defaultValue: 1,
      suffix: 'px',
      validators: [Validators.required],
    },
  ],
  changeHandler: () => {}
}
